import { render, staticRenderFns } from "./TwProcessGroupListInfiniteEditItem.vue?vue&type=template&id=6644491e&scoped=true&"
import script from "./TwProcessGroupListInfiniteEditItem.vue?vue&type=script&lang=js&"
export * from "./TwProcessGroupListInfiniteEditItem.vue?vue&type=script&lang=js&"
import style0 from "./TwProcessGroupListInfiniteEditItem.vue?vue&type=style&index=0&id=6644491e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6644491e",
  null
  
)

export default component.exports